import { mapState, mapActions } from 'vuex';

import { useDataLoading, usePagination, useSearch } from '@mixins/factories';

import SubstrateEditor from '../../_components/substrateEditor';

const dataLoadingOptions = { getterName: 'getSubstrates', contentName: 'substrates' };
const paginationOptions = { contentName: 'substrates' };
const searchOptions = {
  initialSearchDataStates: ['name'],
  searchFieldsConfig: [
    { value: 'name', label: 'Name', type: 'text' },
  ],
};

const substratesHeaders = Object.freeze([
  { text: '', value: 'color', width: '1%' },
  { text: 'Name', value: 'name' },
  { text: 'Abbreviation', value: 'abbreviation' },
  { text: 'Paper Thickness', value: 'paperThickness' },
  { text: '', value: 'actions', width: '5%' },
]);

export default {
  name: 'Substrates',
  mixins: [
    useDataLoading(dataLoadingOptions),
    usePagination(paginationOptions),
    useSearch(searchOptions),
  ],
  components: {
    SubstrateEditor,
  },
  data() {
    return {
      substratesHeaders,
      editorDialog: false,
      isEditorCreateMode: true,
      editedSubstrate: {},
    };
  },
  computed: {
    ...mapState('substrates', ['substrates']),
  },
  watch: {
    suffix() {
      this.$_refreshData();
    },
  },
  methods: {
    ...mapActions('substrates', ['getSubstrates']),
    setEditedSubstrate(substrate) {
      this.editedSubstrate = substrate;
      this.isEditorCreateMode = false;
      this.editorDialog = true;
    },
  },
};
